import React from 'react';
import LegalInfo from '../../elements/Body/LegalInfo/LegalInfo';
import termsOfService from '../../../data/legal/termsOfService.json';
const TermsOfServicePage = () => {
  return (
    <LegalInfo title="Terms of Service" sections={termsOfService.sections} lastUpdated={termsOfService.lastUpdated} />
  );
};
export default TermsOfServicePage;
